<zwi-reference-portal cdkTrapFocus
               [startAt]="referencePicker.startAt"
               [startView]="referencePicker.startView"
               [selected]="referencePicker.selected"
               (closeDialog)="referencePicker.close()"
               (selectedChange)="referencePicker._select($event)"
></zwi-reference-portal>
